import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ComponentNameService } from '@app/services/component-name.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'faxe-page-title',
  imports: [
    AsyncPipe
  ],
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss'
})
export class PageTitleComponent implements OnInit {
  currentComponentName$: Observable<string>;

  constructor(private readonly componentNameService: ComponentNameService) {
  }

  ngOnInit(): void {
    this.currentComponentName$ = this.componentNameService.currentComponentName$;
  }
}
